var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailPoiClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4853 4.01473C18.2188 1.74819 15.2052 0.5 12 0.5C8.79469 0.5 5.78123 1.74819 3.51473 4.01469C1.24823 6.28119 0 9.29469 0 12.5C0 15.7054 1.24819 18.7188 3.51473 20.9853C5.78119 23.2518 8.79469 24.5 12 24.5C15.2052 24.5 18.2188 23.2518 20.4853 20.9853C22.7518 18.7188 24 15.7053 24 12.5C24 9.29464 22.7518 6.28119 20.4853 4.01473ZM17.29 16.7957C17.5645 17.0703 17.5645 17.5155 17.29 17.7901C17.1526 17.9274 16.9727 17.996 16.7928 17.996C16.6129 17.996 16.4329 17.9273 16.2957 17.7901L12 13.4944L7.70433 17.7901C7.56698 17.9274 7.38708 17.996 7.20712 17.996C7.02722 17.996 6.84722 17.9273 6.71002 17.7901C6.43542 17.5155 6.43542 17.0703 6.71002 16.7957L11.0056 12.5L6.71002 8.20438C6.43542 7.92983 6.43542 7.48461 6.71002 7.21002C6.98456 6.93547 7.42973 6.93547 7.70438 7.21002L12 11.5057L16.2956 7.21002C16.5702 6.93547 17.0154 6.93547 17.29 7.21002C17.5645 7.48456 17.5645 7.92978 17.29 8.20438L12.9943 12.5L17.29 16.7957Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailPoiClose);
export default __webpack_public_path__ + "static/media/detail-poi-close.1cd7abec41d5c6ae10f25b561652a533.svg";
export { ForwardRef as ReactComponent };